import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import{ AspAutoscoreService,} from './asp-autoscore.service'

@Component({
  selector: 'app-asp-autoscore',
  templateUrl: './asp-autoscore.component.html',
  styleUrls: ['./asp-autoscore.component.scss']
})
export class AspAutoscoreComponent implements OnInit {
  garageName: string = '';
  garageKey: string = '';
  score: number = 0;
  scale: string = '';
  description: string = '';
  updatedDate: string = '';
  needleRotation: number = 0;
    currentRotation: number = 0; 
      engineAudio: HTMLAudioElement;
      isAutoscoreSidebarOpen: boolean = false;


// ticks: number[] = Array.from({ length: 100 }, (_, i) => i);
bands = [
  { label: 'Poor',      start: 0,   end: 499,  color: '#FF4D4F', grade: 'F' },
  { label: 'Fair',      start: 500, end: 599,  color: '#FF9900', grade: 'D' },
  { label: 'Good',      start: 600, end: 699,  color: '#FADB14', grade: 'A' },
  { label: 'Super',     start: 700, end: 799,  color: '#1890FF', grade: 'AA' },
  { label: 'Excellent', start: 800, end: 1000, color: '#52C41A', grade: 'AAA' }
];
    scoreUpdated: any;

  constructor(private http: HttpClient,
    private aspAutoscoreService: AspAutoscoreService ,
    private viewRef: ViewContainerRef
  ) {}

ngOnInit(): void {
  this.engineAudio = new Audio();
  this.engineAudio.src = 'assets/images/car-engine-starting-43705.mp3';
  this.engineAudio.load();
  
  this.playEngineSound();

  this.garageKey = localStorage.getItem('garageKey') || '';
  this.garageName = localStorage.getItem('spareSelectedGarageName') || 'Garage';

  if (this.garageKey) {
    setTimeout(() => {
      this.getScoreDetails();
    }, 100); 
  }
}


playEngineSound(): void {
  
  if (this.engineAudio) {
    this.engineAudio.currentTime = 0;
    this.engineAudio.play().catch((err) => {
      console.warn('Audio playback failed:', err);
    });

    setTimeout(() => {
      this.engineAudio.pause();
      this.engineAudio.currentTime = 0;
    }, 3000); 
  }
}


getScoreDetails(): void {
 this.aspAutoscoreService.getScoreDetails(this.garageKey).subscribe({
  next: (res: any) => { 
    const data = res.data;
    this.score = data.score;
const matchedBand = this.bands.find(b => this.score >= b.start && this.score <= b.end);
this.scale = matchedBand ? matchedBand.grade : '';

    this.updatedDate = data.updatedDate;
          localStorage.setItem('autoscoreValue', this.score.toString());


   const scaleMap = {
  F: 'poor',
  D: 'fair',
  A: 'good',
  AA: 'very_good',
  AAA: 'excellent'
};

const key = `autoscore_card_${scaleMap[this.scale]}`;
const descObj = data.scoreDescription.find((desc: any) => key in desc);
this.description = descObj ? descObj[key] : 'No description available.';



        this.animateNeedleTo(this.score); 
  },
  error: (err) => {
    console.error('Failed to fetch autoscore data:', err);
  }
});

}



// getTickX(tick: number, radius: number): number {
//   const totalTicks = 100;
//   const angle = 135 + (tick / totalTicks) * 270;
//   return 100 + radius * Math.cos(angle * Math.PI / 180);
// }

// getTickY(tick: number, radius: number): number {
//   const totalTicks = 100;
//   const angle = 135 + (tick / totalTicks) * 270;
//   return 100 + radius * Math.sin(angle * Math.PI / 180);
// }


animateNeedleTo(score: number) {
  const startRotation = -180;
  const targetRotation = this.calculateNeedleAngle(score);
  const duration = 3000; // duration in ms
  const stepStartDelay = 100; // slight delay to ensure audio starts first

  const startAnimation = (startTime: number) => {
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // 0 to 1
      const easedProgress = 1 - Math.pow(1 - progress, 3); // ease-out

      this.needleRotation = startRotation + (targetRotation - startRotation) * easedProgress;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.needleRotation = targetRotation;
        if (this.engineAudio) {
          this.engineAudio.pause();
          this.engineAudio.currentTime = -300;
        }
      }
    };

    requestAnimationFrame(animate);
  };

  // Play audio first, then start animation after a tiny delay
  if (this.engineAudio) {
    this.engineAudio.currentTime = 0;
    const playPromise = this.engineAudio.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Start animation just after audio starts
          setTimeout(() => {
            requestAnimationFrame((t) => startAnimation(t));
          }, stepStartDelay); // delay allows audio to initialize
        })
        .catch((err) => {
          console.warn('Audio play failed:', err);
          // Fallback: still start animation
          requestAnimationFrame((t) => startAnimation(t));
        });
    } else {
      requestAnimationFrame((t) => startAnimation(t));
    }
  } else {
    requestAnimationFrame((t) => startAnimation(t));
  }
}




calculateNeedleAngle(score: number): number {
  return (score / 1000) * 180-90;
}
  getGradeText(scale: string): string {
    const map: { [key: string]: string } = {
       F: 'Poor',
        D: 'Fair',
        A: 'Good',
        AA: 'Very Good', 
        AAA: 'Excellent'
    };
    return map[scale] || '';
  }

  onShare(): void {
  let message = `*🚗 Your Weekly Autoscore Update from Autoverse!*\n\nHey *${this.garageName}!* 👋\n\n📊 *Weekly Autoscore:* ${this.score}\n\n🏆 *Grade:* ${this.scale}\n\n`;

  switch (this.scale) {
    case 'AAA':
      message += "🔍 *Meaning:* Excellent! 🎉 Keep shining bright!\n\nLet's celebrate your success! 🥳";
      break;
    case 'AA':
      message += "🔍 *Meaning:* Superb! 🚀 Keep up the fantastic work!\n\nLet's celebrate your success! 🥳";
      break;
    case 'A':
      message += "🔍 *Meaning:* Good work! 👍 Stay on track!\n\nLet's discuss strategies for improvement. 📈";
      break;
    case 'D':
      message += "🔍 *Meaning:* Fair. Let's work on improvements. 💪\n\nLet's discuss strategies for improvement. 📈";
      break;
    case 'F':
      message += "🔍 *Meaning:* Poor. Let's strategize for progress. 🔄\n\nLet's devise a plan to turn it around. 🌟";
      break;
    default:
      message += "🔍 Let's keep improving together! 💼";
      break;
  }

  const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
}

  getArcPath(start: number, end: number, radius: number): string {
  const startAngle = 135 + (start / 1000) * 270;
  const endAngle = 135 + (end / 1000) * 270;

  const startX = 100 + radius * Math.cos((Math.PI / 180) * startAngle);
  const startY = 100 + radius * Math.sin((Math.PI / 180) * startAngle);

  const endX = 100 + radius * Math.cos((Math.PI / 180) * endAngle);
  const endY = 100 + radius * Math.sin((Math.PI / 180) * endAngle);

  const largeArcFlag = end - start > 500 ? 1 : 0;

  return `M${startX},${startY} A${radius},${radius} 0 ${largeArcFlag} 1 ${endX},${endY}`;
}
getBand(score: number) {
  return this.bands.find(b => score >= b.start && score <= b.end);
}
getNeedleX(score: number): number {
  const angle = 135 + (score / 1000) * 270;
  return 100 + 60 * Math.cos(angle * Math.PI / 180);
}

getNeedleY(score: number): number {
  const angle = 135 + (score / 1000) * 270;
  return 100 + 60 * Math.sin(angle * Math.PI / 180);
}
openAutoscoreSidebar() {
    this.isAutoscoreSidebarOpen = true;
  }

  closeAutoscoreSidebar() {
    this.isAutoscoreSidebarOpen = false;
  
}
}